export const BankingDashboard = {
  Data: {}
}
